import { render, staticRenderFns } from "./BuscarLead.vue?vue&type=template&id=b75541ba"
import script from "./BuscarLead.vue?vue&type=script&lang=js"
export * from "./BuscarLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports